import { addStyles } from 'ethcss'
import { grid, IStyles } from 'theme'
import { mediaCSS, text } from 'theme'

const displaysNotificationsStyles: IStyles = {
    wrapper: {
        ...grid.col,
        ...grid.full,
        ...grid.justify,
        ...grid.p_md,
        [mediaCSS.tabMini]: {
            height: 'auto',
            padding: '16px',
        },
    },
    header: {
        ...grid.row,
        ...grid.center,
        ...grid.normalCenter,
        ...grid.mb_md,
        [mediaCSS.tabMini]: {
            padding: '0 40px',
        },
    },
    selects: {
        ...grid.w100,
        [mediaCSS.tabMini]: {
            ...grid.pl_none,
            ...grid.pr_none,
        },
    },
    checkbox: {
        ...grid.pt_md,
        ...grid.w100,
    },
    inputs: {
        ...grid.row,
        ...grid.mt_md,
        ...grid.w45,
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
    timeInputs: {
        ...grid.row,
        ...grid.pt_mini,
        ...grid.w100,
    },
    timeLeftInputs: {
        ...grid.pt_mini,
        ...grid.w100,
    },
    footer: {
        ...grid.row,
        ...grid.center,
        ...grid.p_md,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
            padding: '16px 0',
        },
    },
    displaysNotifications__icon: {
        ...grid.mr_md,
        [mediaCSS.tabMini]: {
            display: 'none',
        },
    },
    displaysNotifications__title: {
        ...text.mdPlus,
        ...text.bold,
        [mediaCSS.tabMini]: {
            fontSize: 20,
        },
    },
    displaysNotifications__content: {
        ...grid.col,
        width: '54%',
        margin: '0 auto',
        [mediaCSS.tab]: {
            width: '100%',
        },
        [mediaCSS.tabMini]: {
            height: 'auto',
            ...grid.mb_md,
        },
    },
    displaysNotifications__subTitle: {
        ...text.md,
        ...text.left,
        width: '100%',
        [mediaCSS.tabMini]: {
            ...text.normalPlus,
            ...text.center,
        },
    },
    displaysNotifications__inputWrapper_type_startTime: {
        flex: 1,
        ...grid.mr_md,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mr_none,
            ...grid.mb_md,
            flex: 'none',
        },
    },
    displaysNotifications__inputWrapper_type_endTime: {
        flex: 1,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mb_md,
            flex: 'none',
        },
    },
    displaysNotifications__inputWrapper_type_sendInterval: {
        ...grid.w100,
    },
    inputContainer: {
        ...grid.row,
        ...grid.w100,
        ...grid.justify,
        alignItems: 'flex-start',
        [mediaCSS.tab]: {
            ...grid.col,
        },
    },
    leftColumn: {
        ...grid.col,
        ...grid.w45,
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
    rightColumn: {
        ...grid.col,
        ...grid.w45,
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
    checkboxPt: {
        ...grid.pt_md,
    },
    dNone: {
        display: 'none',
    },
    customSelect: {
        '&__control': {
            border: '1px solid #F0F0F0F0 !important',
            boxShadow: 'none !important',
            '&:hover': {
                cursor: 'pointer !important',
            },
        },
        '&__option': {
            cursor: 'pointer !important',
            '&--is-focused': {
                background: 'hsl(0,0%,90%) !important',
            },
            '&--is-selected': {
                color: 'hsl(0,0%,20%) !important',
                background: 'hsl(0,0%,90%) !important',
            },
        },
        '&__indicator-separator': {
            display: 'none !important',
        },
        '&__multi-value__remove': {
            '&:hover': {
                background: 'transparent !important',
            },
        },
    },
}

addStyles(displaysNotificationsStyles)
export default displaysNotificationsStyles
